import { getWithAuth } from '../../../Basic/HttpService';

export const getAllVehicleCheckDaily = async () => {
    let res = await getWithAuth(`VehicleDailyCheck/list`);
    return res;
};
